export const defaultColumns = ['eventTime', 'action', 'eventSource'];
